import i18n from "../../../../../constants/i18n";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-store";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";

const PaidUserInformation = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitY, colors } = theme;

  const isMaleUser =
    getKhattabatMatchingStore().currentClientInformation.get().gender === "m";
  const isFemaleUser =
    getKhattabatMatchingStore().currentClientInformation.get().gender === "f";
  const userStatus =
    getKhattabatMatchingStore().currentClientInformation.get().userStatus;
  const isActiveMatch = userStatus === "active";
  const statusColor = isActiveMatch ? colors.all.green : colors.all.red;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={650}
      height={80}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={300}
        height={80}
        color={""}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={28}
          isSpan={true}
          text={i18n.get("GENDER")}
          style={{
            height: 30 * unitY,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center"
          }}
          color={""}
        />
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={28}
          isSpan={true}
          text={isMaleUser ? "male" : isFemaleUser ? "female" : ""}
          style={{
            height: 50 * unitY,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          color={""}
        />
      </ET3Div>
      <Et3Margin top={0} bottom={0} left={20} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={300}
        height={80}
        color={""}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={28}
          isSpan={true}
          text={i18n.get("STATUS")}
          style={{
            height: 30 * unitY,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center"
          }}
          color={""}
        />
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={28}
          isSpan={true}
          text={userStatus}
          style={{
            height: 50 * unitY,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: statusColor
          }}
          color={""}
        />
      </ET3Div>
    </ET3Div>
  );
});

export default PaidUserInformation;
